import angular from 'angular'
import bidWidgetModule from './bidWidget/bidWidget'

import auctionPaneComponent from './auctionPane.component'

export default angular.module('app.pages.marketplace.loanRequestDetails.auctionPane', [bidWidgetModule.name])
  .directive('auctionPane', auctionPaneComponent)
